import axios from 'axios';

export default {
    state: {
        departmentsDic: null,
    },
    getters: {
        getDepartmentsDic(state) {
            return state.departmentsDic
        },
    },
    mutations: {
        setDepartmentsDic(state, data) {
            return state.departmentsDic = data
        },
    },
    actions: {
        departmentsDicRequest(context) {
            return axios.get('/api/dictionaries/departments')
                .then(res => {
                    context.commit('setDepartmentsDic', res.data)
                })
        },
    }
}